import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getSetupIntent } from 'school-space-client/api';
import { UserContext } from 'school-space-client/components';
import BacsMandate from '../components/documents/bacsMandate';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');

export default function BacsSetup() {
    const [clientSecret, setClientSecret] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [loading, setLoading] = useState(true);

    const user = useContext(UserContext);

    const fetchSetupIntent = useCallback(async () => {
        if (!user?.id) return;

        setLoading(true);
        setErrorMessage(null);

        try {
            const data = await getSetupIntent(user.id);
            setClientSecret(data?.clientSecret);
        } catch (error) {
            console.error('Error fetching setup intent:', error);
            setErrorMessage('Failed to initiate Direct Debit setup. Please try again.');
        } finally {
            setLoading(false);
        }
    }, [user?.id]);

    useEffect(() => {
        fetchSetupIntent();
    }, [fetchSetupIntent]);

    const stripeOptions = {
        clientSecret,
        appearance: {
            layout: {
                type: 'accordion',
                defaultCollapsed: false,
                radios: false,
                spacedAccordionItems: true
            }
        }
    };

    return (
        <div style={{ padding: '40px 20px', maxWidth: '720px', margin: '0 auto' }}>
            {loading && <p>Loading payment setup...</p>}

            {errorMessage && (
                <div
                    style={{
                        backgroundColor: '#ffe6e6',
                        padding: '10px',
                        borderRadius: '4px',
                        color: '#cc0000'
                    }}
                >
                    {errorMessage}
                </div>
            )}

            {!loading && clientSecret && (
                <Elements stripe={stripePromise} options={stripeOptions}>
                    <BacsMandate />
                </Elements>
            )}
        </div>
    );
}
